import { PropsWithChildren } from 'react';
import cn from 'classnames';
import styles from './spacing.module.scss';

export enum SpacingDirection {
  vertical = 'vertical',
  horizontal = 'horizontal',
  both = 'both',
}

export enum SpacingSize {
  large = 'large',
  medium = 'medium',
  small = 'small',
  xsmall = 'xsmall',
}

export type SpacingProps = PropsWithChildren & {
  size?: SpacingSize;
  direction?: SpacingDirection;
  className?: string;
};

export const Spacing = ({ size, direction = SpacingDirection.horizontal, children, className }: SpacingProps) => {
  return (
    <div className={cn(styles.spacing, className, styles[`spacing-${size}`], styles[`spacing-${direction}`])}>
      {children}
    </div>
  );
};
